import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";

import { ChakraProvider } from "@chakra-ui/react";
import theme from "../components/theme"; // Przypisanie motywu z eksportu z pliku theme.js
import NavBar from "./navbar";
import Footer from "./footer";
import { Box } from "@chakra-ui/react";
import { IntlProvider } from "react-intl"; // Importujemy `IntlProvider` z `react-intl`
import messages_en from "../intl/en.json"; // Zakładając, że pliki tłumaczeń są w `src/intl`
import messages_pl from "../intl/pl.json";

const messages = { en: messages_en, pl: messages_pl };
const language = typeof navigator !== "undefined" ? navigator.language.split("-")[0] : "en";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <IntlProvider locale={language} messages={messages[language]}>
      <ChakraProvider theme={theme}>
        <NavBar />
        <Box
          as="main"
          style={{
            margin: `0 auto`,
            maxWidth: `var(--size-content)`,
          }}
        >
          {children}
          <Footer />
        </Box>
      </ChakraProvider>
    </IntlProvider>
  );
};

export default Layout;
